import React from 'react';
import Container from 'react-bootstrap/Container';

const Layout = (props) => {
    return ( 
        <Container className="bg-darkPurple" fluid="md">
            {props.children}
        </Container>
     );
}
 
export default Layout;